module.exports = __webpack_public_path__ + "img/norberto_trillo.b0f7729f.png";